import React, { useContext, useState, useEffect } from 'react'
import { useGoogleLogin } from '@react-oauth/google'
import './googlelogin.css'

import { AuthContext } from '../../context/authContext'

// Detect in-app browsers (LinkedIn, Facebook, Instagram, etc.)
const isInAppBrowser = () => {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || navigator.vendor || window.opera || ''
  // LinkedIn uses various identifiers: LinkedIn, LinkedInApp, LKDN
  return /FBAN|FBAV|Instagram|LinkedIn|LinkedInApp|LKDN|Snapchat|Twitter|Line|Pinterest|TikTok|WebView|wv\)/i.test(ua)
}

const GoogleLoginComponent = () => {
  const { login } = useContext(AuthContext)
  // Detect immediately on initial render, not in useEffect
  const [isInApp] = useState(() => isInAppBrowser())
  const [copied, setCopied] = useState(false)

  const googleLoginFunction = useGoogleLogin({
    onSuccess: async codeResponse => {
      const request = await fetch(
        `https://www.googleapis.com/oauth2/v3/userinfo?access_token=${codeResponse.access_token}`
      )
      const user = await request.json()
      login(user, 'google')
    }
  })

  // Force refresh - simple reload with cache bust
  const forceRefresh = () => {
    // Just reload with cache-busting parameter
    window.location.href = window.location.origin + window.location.pathname + '?r=' + Date.now()
  }

  // Copy URL with cache-busting parameter
  const copyUrl = async () => {
    try {
      // Add cache-busting param to copied URL
      const url = new URL(window.location.origin + window.location.pathname)
      url.searchParams.set('v', Date.now())
      await navigator.clipboard.writeText(url.toString())
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      // Fallback for older browsers
      const url = window.location.origin + window.location.pathname + '?v=' + Date.now()
      const textArea = document.createElement('textarea')
      textArea.value = url
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }
  }

  // Show special UI for in-app browsers
  if (isInApp) {
    return (
      <div className='row mt-3'>
        <div className='col-md-12'>
          <div style={{
            background: 'linear-gradient(135deg, #ff416c, #ff4b2b)',
            borderRadius: '12px',
            padding: '20px',
            textAlign: 'center',
            color: '#fff'
          }}>
            <div style={{ fontSize: '32px', marginBottom: '10px' }}>🔒</div>
            <h4 style={{ marginBottom: '10px', fontWeight: '600' }}>Open in Browser</h4>
            <p style={{ fontSize: '14px', marginBottom: '15px', opacity: 0.9 }}>
              Google login doesn't work in app browsers.<br/>
              Please open in Chrome or Safari.
            </p>
            <button
              onClick={copyUrl}
              style={{
                background: '#fff',
                color: '#ff416c',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '14px',
                cursor: 'pointer',
                width: '100%',
                marginBottom: '10px'
              }}
            >
              {copied ? '✓ Copied!' : '📋 Copy Link'}
            </button>
            <p style={{ fontSize: '12px', opacity: 0.8, marginBottom: '12px' }}>
              Paste in Chrome/Safari to login
            </p>
            <button
              onClick={forceRefresh}
              style={{
                background: 'rgba(255,255,255,0.2)',
                color: '#fff',
                border: '1px solid rgba(255,255,255,0.3)',
                padding: '10px 20px',
                borderRadius: '8px',
                fontWeight: '500',
                fontSize: '13px',
                cursor: 'pointer',
                width: '100%'
              }}
            >
              🔄 Page not loading? Tap to Refresh
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='row mt-5'>
      <div className='col-md-12'>
        <div
          onClick={() => {
            googleLoginFunction()
          }}
          className='google-btn d-flex align-items-center mb-3'
        >
          <div className='align-items-center d-flex google-icon-wrapper justify-content-center'>
            <img
              className='google-icon'
              src='assets/images/goo.svg'
              alt='google'
            />
          </div>
          <p className='btn-text d-flex flex-grow h-100 justify-content-center mb-0 w-100 align-items-center'>
            <b>Sign in with google</b>
          </p>
        </div>
      </div>
    </div>
  )
}

export default GoogleLoginComponent
